<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<div class="figure" style="text-align: center; margin-top:160px; ">
<img alt="" src="media/file0.jpg" style="width:3.86389in;height:5.89848in"/>
<p class="caption">Text, letter Description automatically generated</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?9d1c080e